import {useState} from "react";
import {Button} from "@progress/kendo-react-buttons";
import {Window, WindowActionsBar} from "@progress/kendo-react-dialogs";
import {TextBox} from "@progress/kendo-react-inputs";
import axios from "axios";
import config from "../../config/config.json";

const RenameInvoiceDialog = props => {
    const [oldInvoiceNum, setOldInvoiceNum] = useState("");
    const [newInvoiceNum, setNewInvoiceNum] = useState("");
    const [preview, setPreview] = useState(null);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [done, setDone] = useState(false);

    const requestData = () => ({
        oldInvoiceNum: oldInvoiceNum.trim(),
        newInvoiceNum: newInvoiceNum.trim(),
    });

    const getInputValue = event => event.value ?? event.target.value;

    const handlePreview = async () => {
        setIsLoading(true);
        setError("");
        setDone(false);
        setPreview(null);

        try {
            const response = await axios.post(config.API_URL + "invoice/rename/preview", requestData(), {
                headers: {"x-api-key": sessionStorage.getItem("apiKEY")},
            });
            setPreview(response.data);
        } catch (error) {
            setError(error.response?.data?.error || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRename = async () => {
        setIsLoading(true);
        setError("");

        try {
            const response = await axios.post(config.API_URL + "invoice/rename", requestData(), {
                headers: {"x-api-key": sessionStorage.getItem("apiKEY")},
            });
            setPreview(response.data);
            setDone(true);
        } catch (error) {
            setError(error.response?.data?.error || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const canPreview = oldInvoiceNum.trim() !== "" && newInvoiceNum.trim() !== "";
    const canRename = preview && !done && !isLoading;

    return (
        <Window
            title={"Opravit číslo faktury"}
            onClose={props.onClose}
            initialHeight={420}
            initialWidth={620}
            modal={true}
            resizable={false}
        >
            <div className="invoice-rename-dialog">
                <div className="invoice-dialog-textbox">
                    <h2>Původní číslo</h2>
                    <TextBox
                        value={oldInvoiceNum}
                        onChange={(event) => {
                            setOldInvoiceNum(getInputValue(event));
                            setPreview(null);
                            setDone(false);
                        }}
                    />
                </div>

                <div className="invoice-dialog-textbox">
                    <h2>Nové číslo</h2>
                    <TextBox
                        value={newInvoiceNum}
                        onChange={(event) => {
                            setNewInvoiceNum(getInputValue(event));
                            setPreview(null);
                            setDone(false);
                        }}
                    />
                </div>

                {error && <div className="invoice-rename-error">{error}</div>}
                {done && <div className="invoice-rename-success">Číslo faktury bylo změněno.</div>}

                {preview && (
                    <div className="invoice-rename-preview">
                        <div><strong>Změna:</strong> {preview.oldInvoiceNum} → {preview.newInvoiceNum}</div>
                        <div><strong>Klient:</strong> {preview.clientNames?.length ? preview.clientNames.join(", ") : "nenalezen"}</div>
                        <div><strong>Výkaz práce:</strong> {preview.tmsCount}</div>
                        <div><strong>Náklady:</strong> {preview.expensesCount}</div>
                        <div><strong>Celkem položek:</strong> {preview.totalCount}</div>
                    </div>
                )}
            </div>

            <WindowActionsBar layout="end">
                <Button onClick={props.onClose} disabled={isLoading}>
                    Zavřít
                </Button>
                <Button themeColor={"primary"} onClick={handlePreview} disabled={!canPreview || isLoading}>
                    Zkontrolovat
                </Button>
                <Button themeColor={"success"} onClick={handleRename} disabled={!canRename}>
                    Potvrdit změnu
                </Button>
            </WindowActionsBar>
        </Window>
    );
};

export default RenameInvoiceDialog;
